module.exports = __webpack_public_path__ + "img/cache-first.01cbdaa1.png";